module.exports = __webpack_public_path__ + "img/menu.4a405515.svg";